import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function LoginForm() {
  const navigate = useNavigate();

  useEffect(() => {
    // Store session and redirect immediately
    sessionStorage.setItem('isAuthenticated', 'true');
    navigate('/report/onc-cjv-cbs');
  }, [navigate]);

  return null;
}

export default function Login() {
  return <LoginForm />;
} 